'use client';

import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUp } from 'lucide-react';

export function ScrollToTop() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handler = () => setShow(window.scrollY > 400);
        window.addEventListener('scroll', handler, { passive: true });
        return () => window.removeEventListener('scroll', handler);
    }, []);

    return (
        <AnimatePresence>
            {show && (
                <motion.button
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="fixed bottom-28 lg:bottom-24 right-6 z-40 w-10 h-10 rounded-full bg-blue-600/90 hover:bg-blue-500 text-white shadow-lg shadow-blue-500/30 flex items-center justify-center transition-colors backdrop-blur-sm cursor-pointer"
                    title="맨 위로"
                >
                    <ChevronUp className="w-5 h-5" />
                </motion.button>
            )}
        </AnimatePresence>
    );
}
